import { getField, updateField } from 'vuex-map-fields'
import { getNewId } from '@/utils/id'
import BaseStore from '@/store/baseStore'
import api from '../api/api'
import { REVISION_KEY } from '@/components/constant'

export const namespaced = true

const baseUrl = '/stage_configuration/'

const baseStore = new BaseStore(baseUrl)

const getDefaultState = () => ({
  ...structuredClone(baseStore.state),
  currentOverviewHeadLine2: null
})
export const state = getDefaultState()

export const mutations = {
  ...baseStore.mutations,
  ADD_END_ITEM(state, item) {
    state.items.push(item)
  },
  RESET_STATE(state) {
    Object.assign(state, getDefaultState())
  },
  SET_NUMBER(state, { item, number }) {
    item.number = number
  },
  updateField
}
export const actions = {
  ...baseStore.actions,
  resetState({ commit }) {
    commit('RESET_STATE')
  },
  async add(context) {
    let id = getNewId(context.state.items, 'id')
    let item = context.getters.getEmptyStageConfiguration(id)
    item.topo_profile = !context.state.items.length
    context.commit('ADD_END_ITEM', item)
    context.commit('ADD_COUNT', 1)
  },
  async deleteItem(context, id) {
    if (id > 0) {
      let url = context.state.baseUrl + `${id}/`
      await api.delete(url)
    }
    context.commit('DELETE_ITEM', id)
    for (const [index, item] of context.state.items.entries()) {
      if (item.number > index + 1) {
        context.commit('SET_NUMBER', { item, number: item.number - 1 })
      }
    }
  }
}

export const getters = {
  getField,
  getEmptyStageConfiguration: (state, getters, rootState, rootGetters) => (id) => {
    let emptyObj = {}
    let defaultNumber = 1
    if (state.items.length) {
      defaultNumber = Math.max(...state.items.map((item) => item.number)) + 1
    }
    Object.keys(state.options).forEach((key) => {
      if (state.options[key].type === 'choice') {
        emptyObj[key] = state.options[key]['choices'][0].value
      } else if (state.options[key].type === 'boolean') {
        emptyObj[key] = false
      } else if (state.options[key].type === 'string') {
        emptyObj[key] = ''
      } else {
        emptyObj[key] = null
      }
    })
    emptyObj.id = id
    emptyObj.stage_configuration_revision = rootGetters['project/selectedRevision'](
      REVISION_KEY.STAGE_CONFIGURATION
    ).id
    emptyObj.number = defaultNumber
    return emptyObj
  }
}
